import { render, staticRenderFns } from "./revolva.toolBar.vue?vue&type=template&id=22bf9221&scoped=true&"
import script from "./revolva.toolBar.vue?vue&type=script&lang=ts&"
export * from "./revolva.toolBar.vue?vue&type=script&lang=ts&"
import style0 from "./revolva.toolBar.vue?vue&type=style&index=0&id=22bf9221&lang=scss&scoped=true&"
import style1 from "./revolva.toolBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf9221",
  null
  
)

export default component.exports